import React from 'react';
import SectionComponent from "./SectionComponent";
import { IMG_PRE_CONSTRUCTION } from "../../data/constructionServiceImages";

function PreConstruction() {
  return (
    <SectionComponent
      images={IMG_PRE_CONSTRUCTION}
      titles={{
        mainTitle: "Pre-construction",
        subTitle: "Buildability input, scope clarity, and delivery planning",
        sectionTitle1: "Early review",
        sectionTitle2: "Scope & procurement alignment",
        sectionTitle3: "Risk and programme",
        sectionTitle4: "Project photography",
      }}
      descriptions={{
        sectionDescription1: "We work with architects and consultants during design development to flag buildability constraints, sequencing issues, and interfaces that will matter on site. The goal is fewer surprises at mobilisation.",
        sectionDescription2: "We align trade packages, long-lead items, and inspection hold points with your design milestones so pricing reflects how the project will actually be built.",
        sectionDescription3: "We build a realistic programme narrative—dependencies, weather-critical work, and coordination windows—so clients see how design intent translates into site activity.",
        imageAlt: "Construction site and structural works"
      }}
      galleryLink="/projects/mixed-use"
      seo={{
        title: "Pre-construction & buildability",
        description: "Pre-construction planning, buildability input, and programme alignment for architects and developers. MA Renovations, Glasgow."
      }}
    />
  )
}

export default PreConstruction;
